import { ToggleButton } from "@mui/material";

const CustomToggleButton = ({
  value,
  disabled,
  id,
  children
}) => {
  return (
    <ToggleButton
      value={value}
      aria-label={value}
      disabled={disabled}
      id={id}
      sx={{
        border: "none",
        "&.Mui-selected": {
          border: "none",
          borderRadius: "3px",
        },
      }}
    >
      { children }
    </ToggleButton>
  )
};

export default CustomToggleButton;